<template>
    <div>
        <b-row v-show="mostrarDetalhes">
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DADOS CADASTRAIS
                            <span v-if="mostrarOperacao">
                                -
                                <b-badge variant="warning">{{
                                    operacao
                                }}</b-badge>
                            </span>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <dados-fornecedor
                            :fornecedor="fornecedor"
                            v-if="erros.length == 0"
                        ></dados-fornecedor>
                    </b-card-body>
                    <b-card-footer v-if="mostrarOperacao">
                        <b-button
                            variant="primary"
                            v-if="mostrarBtnAtualizar"
                            @click.stop="transferirParaAtualizacao()"
                            class="mr-2"
                        >
                            <i class="fa fa-edit"></i> Atualizar
                        </b-button>
                        <btn-mostrar-atualizacao-pendente
                            v-if="!mostrarBtnAtualizar && fornecedor"
                            :dadosCadastraisId="fornecedor.atualizacaoPendente"
                        ></btn-mostrar-atualizacao-pendente>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <router-view @obterDadosCadastrais="obterFornecedor()"></router-view>
    </div>
</template>

<script>
import DadosCadastraisServicos from './DadosCadastraisServicos'
import BtnMostrarAtualizacaoPendente from './BtnMostrarAtualizacaoPendente'
import DadosFornecedor from './DadosFornecedor'

export default {
    props: {
        fornecedorId: {
            type: String,
            default: () => null
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        BtnMostrarAtualizacaoPendente,
        DadosFornecedor
    },

    data() {
        return {
            fornecedor: null,
            operacao: 'DETALHAR',
            erros: []
        }
    },

    methods: {
        obterFornecedor() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedorId) {
                promisse = this.dataServico.obterDados(this.fornecedorId)
            } else {
                promisse = DadosCadastraisServicos.obterDados()
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.fornecedor = response.data
                        this.normalizarFornecedor()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        normalizarFornecedor() {
            this.fornecedor.ultimaAtualizacao = this.$maskDate(
                this.fornecedor.ultimaAtualizacao
            )
            this.fornecedor.cpfCnpj = this.$maskCpfCnpj(this.fornecedor.cpfCnpj)
            this.fornecedor.telefone = this.$maskTelefone(
                this.fornecedor.telefone
            )
            this.fornecedor.cep = this.$maskCep(this.fornecedor.cep)
        },

        transferirParaAtualizacao() {
            this.$router.push({
                name: 'FornecedorDadosCadastrais_Atualizar'
            })
        }
    },

    computed: {
        mostrarBtnAtualizar() {
            return (
                this.fornecedor &&
                this.$temAcessoView('FORN-DADOS-01') &&
                this.fornecedor.atualizacaoPendente ==
                    '00000000-0000-0000-0000-000000000000'
            )
        },

        mostrarDetalhes() {
            return (
                this.$route.name == 'FornecedorDadosCadastrais' ||
                this.$route.name == 'FornecedoresDadosCadastrais'
            )
        },

        mostrarOperacao() {
            return this.$route.name == 'FornecedorDadosCadastrais'
        }
    },

    created() {
        this.obterFornecedor()
    }
}
</script>
